
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/resolving-parenting-issues",
      function () {
        return require("private-next-pages/blog/resolving-parenting-issues.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/resolving-parenting-issues"])
      });
    }
  